// extracted by mini-css-extract-plugin
export default {"l":"_89287c3ec9"};